import React, { useState, useEffect, useRef } from "react";
import auth from "../auth";
import Version from "version";
import { useConnect } from 'dotnetify';
import { useTranslation } from 'react-i18next';
import { withStyles, useTheme } from '@material-ui/core/styles';
import PageContainer from '../controls/PageContainer';
import ServerState from '../controls/ServerState';
import { Grid, Divider, Modal, Typography, LinearProgress } from "@material-ui/core";
import { Box, BoxContent } from "../controls/Box";
import Clipboard from 'react-clipboard.js';
import Tooltip from '@material-ui/core/Tooltip';
import { LargeButton, SmallButton } from '../controls/components/Buttons';
import SparkleDialog from '../controls/components/SparkleDialog';

const BlackTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        boxShadow: theme.shadows[1],
        fontSize: 11,
        fontFamily: 'Arial',
    },
    arrow: {
        color: theme.palette.common.black,
    }
}))(Tooltip);


export default function Invoice() {
    const { t } = useTranslation();
    const getParameterByName = (name) => {
        var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    };
    const { vm, state } = useConnect("Invoice", { PdfBuzy: false }, {
        headers: {
            Authorization: "Bearer " + auth.getAccessToken(),
            ClientVersion: Version.getVersion(),
            ServerToken: window.sessionStorage.ServerToken
        },
        vmArg: {
            InvoiceNo: getParameterByName('invoiceNo'),
        },
        exceptionHandler: _ => auth.signOut()
    });
    const dialogRef = useRef();
    //useEffect(() => {
    //    if (state.InvoicePdfCode !== undefined && state.InvoicePdfCode !== '' && state.InvoicePdfCode !== null) {
    //        setTimeout(
    //            function () {
    //                var uri = window.location.protocol + '//' + window.location.host;
    //                dialogRef.current.openUrl('https://mozilla.github.io/pdf.js/web/viewer.html?file=' + uri + `/api/document/pdf/${state.InvoicePdfCode}`);
    //            },
    //            10
    //        );
    //    }
    //}, [state.InvoicePdfCode])
    const theme = useTheme();
    const [AccountTipOpen, setAccountTipOpen] = useState(false);
    const [OcrTipOpen, setOcrTipOpen] = useState(false);
    const copySuccess = (type) => {
        if (type === 'ocr') {
            setOcrTipOpen(true);
        } else {
            setAccountTipOpen(true);
        }
        setTimeout(
            function () {
                if (type === 'ocr') {
                    setOcrTipOpen(false);
                } else {
                    setAccountTipOpen(false);
                }
            }.bind(this),
            2000
        );
    };
    //const wDim = useWindowDimensions();
    return (
        <>
            <ServerState serverState={state} />
            <SparkleDialog ref={dialogRef} />
            <Modal
                aria-labelledby={t('selfcare:label.loadpdf')}
                aria-describedby={t('selfcare:label.downloadpdf')}
                open={state.PdfBuzy}
            >
                <div style={{ width: '300px', top: '50%', left: '50%', transform: `translate(-50%, -50%)`, position: 'absolute', backgroundColor: theme.palette.background.paper, boxShadow: theme.shadows[5], padding: theme.spacing(2), outline: 'none' }}>
                    <Typography id="modal-title">
                        {state.PdfBuzyText}
                    </Typography>
                    <LinearProgress color="primary" variant="query" />
                </div>
            </Modal>
            <PageContainer back title={state.InvoiceDetail?.Month}>
                <div style={{ marginTop: '19px', width: '100%' }}>
                    {state.IsNorway && <div style={{ fontFamily: theme.typography.fontFamily2, fontSize: '12px', width: '100%', textAlign: 'center' }}><div style={{ fontSize: '11px', color: '#969696', marginLeft: '-260px', transform: 'matrix(0.87, -0.5, 0.5, 0.87, 0, 0)' }}>Tips!</div>Trykk på KID- og kontonummeret for å kopiere det</div>}
                    <Box background fullWidth>
                        <div style={{ fontSize: '12px' }}>
                            {state.IsNorway && state.InvoiceDetail?.InDebtCollection &&
                                <Grid container direction="column" justify="center" alignItems="center">
                                    <div style={{ fontSize: '24px', marginBottom: '17px' }}>
                                        Inkassosak
                                </div>
                                    <div>
                                        OBS! Denne fakturaen ble sendt ut: {state.InvoiceDetail?.InvoiceDate}. Den har dessverre stått ubetalt så lenge at den er blitt oversendt til inkasso. Bruk betal-knappen under for å bli sendt direkte til inkassosaken.
                                </div>
                                    <LargeButton color="primary" onClick={() => { dialogRef.current.openUrl('https://minside.sveafinans.no/', true); }} style={{ marginBottom: '17px', marginTop: '17px' }}>Betal</LargeButton>
                                    <Divider style={{ width: '100%', marginBottom: '1px', marginTop: '1px' }} />
                                    <div style={{ fontSize: '24px', marginTop: '17px', marginBottom: '17px' }}>
                                        Original faktura
                                </div>
                                    <div style={{ marginBottom: '17px' }}>
                                        NB! Inkassaken over må betales. Original faktura er ikke lenger gyldig betalingsmåte, fordi denne har vært ubetalt over flere forfall.
                                </div>
                                </Grid>
                            }
                            {state.IsNorway && <Grid container direction="row" justify="space-between" alignItems="center" style={{ marginBottom: '7px' }}>
                                <div style={{ fontWeight: 300 }}>Forfallsdato</div>
                                <div>{state.InvoiceDetail?.DueDate}</div>
                            </Grid>}
                            {state.IsSweden &&
                                <>
                                    <Grid container direction="row" justify="space-between" alignItems="center" style={{ marginBottom: '7px' }}>
                                        <div style={{ fontWeight: 300 }}>Fakturanummer</div>
                                        <div>{state.InvoiceDetail?.InvoiceNo}</div>
                                    </Grid>
                                    <Grid container direction="row" justify="space-between" alignItems="center" style={{ marginBottom: '7px' }}>
                                        <div style={{ fontWeight: 300 }}>Fakturadatum</div>
                                        <div>{state.InvoiceDetail?.InvoiceDate}</div>
                                    </Grid>
                                </>
                            }
                            {state.IsNorway &&
                                <>
                                    <Grid container direction="row" justify="space-between" alignItems="center" style={{ marginBottom: '7px' }}>
                                        <div style={{ fontWeight: 300 }}>Kontonummer</div>
                                        <div>
                                            <BlackTooltip
                                                PopperProps={{
                                                    disablePortal: true,
                                                }}

                                                open={AccountTipOpen}
                                                disableFocusListener
                                                disableHoverListener
                                                disableTouchListener
                                                title="Kontonummer kopiert"
                                                placement="top"
                                                arrow
                                            >
                                                <Clipboard component="div" data-clipboard-text={state.InvoiceDetail?.AccountNo} onSuccess={() => copySuccess('account')} style={{ cursor: 'pointer', borderRadius: '10px', padding: '0px 7px', backgroundColor: '#E5E5E57B', marginRight: '-8px', textAlign: 'right' }}>
                                                    {state.InvoiceDetail?.AccountNo}
                                                </Clipboard>
                                            </BlackTooltip>
                                        </div>
                                    </Grid>
                                    <Grid container direction="row" justify="space-between" alignItems="center" style={{ marginBottom: '17px' }}>
                                        <div style={{ fontWeight: 300 }}>KID-nummer</div>
                                        <div>
                                            <BlackTooltip
                                                PopperProps={{
                                                    disablePortal: true,
                                                }}

                                                open={OcrTipOpen}
                                                disableFocusListener
                                                disableHoverListener
                                                disableTouchListener
                                                title="KID-nummer kopiert"
                                                placement="top"
                                                arrow
                                            >
                                                <Clipboard component="div" data-clipboard-text={state.InvoiceDetail?.OcrNo} onSuccess={() => copySuccess('ocr')} style={{ cursor: 'pointer', borderRadius: '10px', padding: '0px 7px', backgroundColor: '#E5E5E57B', marginRight: '-8px', textAlign: 'right' }}>
                                                    {state.InvoiceDetail?.OcrNo}
                                                </Clipboard>
                                            </BlackTooltip>
                                        </div>
                                    </Grid>
                                </>
                            }
                            <Grid container direction="row" justify="space-between" alignItems="center" style={{ marginBottom: '7px' }}>
                                <div style={{ fontWeight: 300 }}>{state.IsNorway ? 'Beløp' : 'Totalbelopp'}</div>
                                <div style={{ fontSize: '18px' }}>{state.InvoiceDetail?.Amount}</div>
                            </Grid>
                            <Grid container direction="row" justify="space-between" alignItems="baseline" style={{ marginBottom: '7px' }}>
                                <SmallButton onClick={() => {
                                    var uri = window.location.protocol + '//' + window.location.host;
                                    vm.$dispatch({ GetInvoicePdf: { InvoiceNo: state.InvoiceNo, ReturnType: 'url' } });
                                    fetch(uri + `/api/document/pdf/${state.InvoiceDetail.InvoiceNo}.pdf`)
                                        .then(() => { dialogRef.current.openUrl('https://mozilla.github.io/pdf.js/web/viewer.html?file=' + uri + `/api/document/pdf/${state.InvoiceDetail.InvoiceNo}.pdf`); });
                                }}>{state.IsNorway ? 'Åpne faktura' : 'Öppna faktura'}</SmallButton>
                                <div style={{ fontSize: '14px' }}><span style={{ color: state.InvoiceDetail?.PaymentStatusColor }}>{state.InvoiceDetail?.PaymentStatus}</span>{state.InvoiceDetail?.PaymentSubStatus && <><span> - </span><span style={{ color: state.InvoiceDetail?.PaymentSubStatusColor }}>{state.InvoiceDetail?.PaymentSubStatus}</span></>}</div>
                            </Grid>
                            {state.IsNorway &&
                                <Grid container direction="row" justify="space-between" alignItems="baseline">
                                <SmallButton onClick={() => {
                                    var uri = window.location.protocol + '//' + window.location.host;
                                    vm.$dispatch({ GetSpecificationPdf: { InvoiceNo: state.InvoiceNo, ReturnType: 'url' } });
                                    fetch(uri + `/api/document/pdf/${state.InvoiceDetail.InvoiceNo}_spes.pdf`)
                                        .then(() => { dialogRef.current.openUrl('https://mozilla.github.io/pdf.js/web/viewer.html?file=' + uri + `/api/document/pdf/${state.InvoiceDetail.InvoiceNo}_spes.pdf`); });
                                }} disabled={!state.InvoiceDetail?.HasSpecification}>{state.IsNorway ? 'Åpne spesifikasjon' : 'Öppna specifikation'}</SmallButton>
                            </Grid>
                            }
                        </div>
                    </Box>
                    {state.IsNorway && <div style={{ fontSize: '12px', fontFamily: theme.typography.fontFamily2, fontWeight: 300, textAlign: 'center', width: '100%', marginTop: '-10px' }}>
                        {state.IsNorway ? 'Detaljert spesifikasjon under «Åpne spesifikasjon» slettes automatisk 2 måneder etter fakturadato.' : 'Detaljerad specifikation under «Öppna specifikation» raderas automatiskt 2 månader efter fakturadatum.'}
                    </div>}
                </div>
            </PageContainer>
        </>
    );
}